import styled from 'styled-components';
import { FlexBetween } from '../../../styled/common';
import { Typography } from '../Typography';

export const SwitchLabelContainer = styled.label`
  display: block;
  width: 100%;
  height: 44px;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
`;

export const SwitchContainer = styled(FlexBetween)`
  height: 100%;
  width: 100%;
  align-items: center;
`;

export const SwitchLabel = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const SwitchThumb = styled.span`
  position: absolute;
  top: 3px;
  left: 3px;
  width: 25px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.systemColors.white};
  border-radius: 50%;
  transition: transform 0.2s ease-in-out;
`;

export const SwitchTrack = styled.div`
  position: relative;
  width: 51px;
  height: 31px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.background.quaternary};
  transition: background-color 0.2s ease-in-out;
  flex-shrink: 0;
`;

export const SwitchToggleWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: -1;

  &:checked {
    ~ ${SwitchTrack} {
      background-color: ${({ theme }) => theme.colors.systemColors.blue};

      ${SwitchThumb} {
        transform: translateX(20px);
      }
    }
  }

  &:disabled {
    ~ ${SwitchTrack} {
      opacity: 0.5;
    }
  }
`;
